import { FIELD_TIME_FORMAT_OPTIONS, USER_DATE_FORMAT_OPTIONS } from '../../services/user-date-time-format.service';
import { TEMPLATE_FIELD_TYPES, type TemplateFieldFontFamily, type TemplateFieldType } from '../../models/template.models';
import type { FieldPaletteItem } from './field-configurator.models';

export const FIELD_LABELS: Record<TemplateFieldType, string> = {
  signature: 'Signature',
  initials: 'Initials',
  textbox: 'Textbox',
  date_signed: 'Date signed',
  checkbox: 'Checkbox',
  radio: 'Radio',
  name: 'Name',
  email: 'Email',
  title: 'Title',
  company: 'Company',
  editable_date: 'Editable Date',
  image: 'Image',
  dropdown: 'Dropdown',
};

export const FIELD_ICON_IDS: Record<TemplateFieldType, string> = {
  signature: 'signature',
  initials: 'initials',
  textbox: 'textbox',
  date_signed: 'date',
  checkbox: 'checkbox',
  radio: 'radio',
  name: 'person',
  email: 'email',
  title: 'briefcase',
  company: 'briefcase',
  editable_date: 'date',
  image: 'image',
  dropdown: 'dropdown',
};

export const FIELD_PALETTE: FieldPaletteItem[] = TEMPLATE_FIELD_TYPES.map((type) => ({
  type,
  label: FIELD_LABELS[type],
  iconId: FIELD_ICON_IDS[type],
}));

export const FONT_FAMILY_OPTIONS: TemplateFieldFontFamily[] = [
  'Helvetica',
  'Courier',
  'Times New Roman',
  'Noto Sans',
  'Carlito',
];

export const FONT_ALIGNMENT_OPTIONS = ['left', 'center', 'right'] as const;
export const TEXTBOX_VALIDATION_OPTIONS = ['none', 'email', 'number', 'minimum', 'maximum', 'regex'] as const;
export const TEXTBOX_VALIDATION_UI_OPTIONS = ['none', 'email', 'number', 'minimum', 'maximum'] as const;
export const OPTION_VALIDATION_OPTIONS = ['none', 'minimum', 'maximum', 'exact'] as const;
export const TEXTBOX_RESIZE_OPTIONS = [
  'grow_horizontally',
  'grow_vertically',
  'grow_both',
  'fixed',
  'auto_resize_font',
] as const;
export const DATE_FORMAT_OPTIONS = USER_DATE_FORMAT_OPTIONS;
export const TIME_FORMAT_OPTIONS = FIELD_TIME_FORMAT_OPTIONS;
export const NON_RESIZABLE_FIELD_TYPES = new Set<TemplateFieldType>([
  'date_signed',
  'checkbox',
  'radio',
  'name',
  'email',
  'editable_date',
]);

export const LEGACY_AUTO_GROUP_KEY_PATTERN =
  /^(?:checkbox|radio)-group-[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const DEFAULT_SENDER_ACTIONS = {
  allowEditing: true,
  allowDeletion: true,
  requireDefaultValue: false,
} as const;

export const DEFAULT_FONT_SETTINGS = {
  family: 'Helvetica',
  size: 13,
  lineHeight: 15,
  bold: false,
  italic: false,
  underline: false,
  color: '#000000',
  align: 'left',
  rtl: false,
  characterSpacing: 0,
} as const;
